import { render, staticRenderFns } from "./DenormalizedChildren.vue?vue&type=template&id=68a12594&"
import script from "./DenormalizedChildren.vue?vue&type=script&lang=js&"
export * from "./DenormalizedChildren.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports